import FileCommonType from '../File/FileWebModel';

/** Базовый класс для view-model форм. */
export type BaseFormType = {
	/** Идентификатор компонента. */
	componentId: string | null;
	/** Идентификатор дела. */
	fileId: string;
	/** валидности модели.  */
	notValid?: boolean;
};

/** Базовый тип почти для всех типов задач */
export type TransitionTaskTemplateType = TaskTemplateType & {
	/** Действие  */
	transitionAction: string;
	/** Переходы */
	transitions: Array<TransitionType>;
};

export type TransitionType = {
	title: string;
	to: string;
	action: TransitionAction;
	askComment: boolean;
	condition: ConditionalType;
};

export enum TransitionAction {
	Cancel,
	Submit,
	Error,
	Abort,
}

export type ConditionalType = {
	expression: string;
};

export const TransitionActionTypes = ['Cancel', 'Submit', 'Error', 'Abort'];

/** Класс для получения данных задачи с указанным Action перехода */
export type TransitionActionTaskBaseModel = {
	fileId: string;
	componentId: string;
	transitionAction: string;
	comment: string | null;
	/** шаг к которому надо будет перейти */
	to: string;
	/** Флаг окончательного перехода на следующий шаг */
	go?: boolean;
};

export type TransitionCompleteResponse = {
	recid: string;
	refreshtask?: boolean;
	refreshattach?: boolean;
	kickuser?: boolean;
	revision?: string | null;
	attachmentId?: string | null;
	hasError: boolean;
	errorMessage: string | null;
};

export type KeyPairType = {
	key: string;
	value: string;
};

export enum StatusCharacteristic {
	/** Характеристика не установлена. */
	Unset = 0,
	/** Финальный статус. Задача завершена. */
	FinalStateCompleted = 1,
	/** Финальный статус. Задача отменена. */
	FinalStateCanceled = 2,
	/** Промежуточный статус. Задача в процессе выполнения. */
	IntermediateStateInProgress = 3,
}

export type StatusItemType = {
	characteristic: StatusCharacteristic;
	description: string;
	inProgress: boolean;
	isClosed: boolean;
	key: string;
	order: number;
};

/** View-model для отображения задачи. */
export interface TaskTemplateType extends BaseFormType {
	/** Заголовок. */
	title: string;
	/** Имя автора. */
	authorName: string;
	/** Имя организации автора. */
	authorOrgName: string;
	/** Дата создания. */
	createdDate: string;
	/** Имя исполнителя. */
	executorName: string;
	/** Имя организации исполнителя. */
	executorOrgName: string;
	/** Аватар исполнителя */
	executorAvatar: string;
	/** Срок выполнения. */
	dueDate: string | null;
	/** Описание. */
	description: string;
	/** Примечание */
	comment: string;
	/** Статус задачи */
	statusItem: StatusItemType;
	/** Идентификатор Задачи */
	taskId: string;
	/** Видна ли кнопка редактирования задачи */
	editTaskButtonEnabled: boolean;
	/** asd */
	taskOpen: boolean;
	/** задача в работае */
	taskInWork: boolean;
	/** Зависимые элементы компонента. Вложения */
	relatedAttachments: Array<KeyPairType>;
	/** Зависимые элементы компонента. Задачи */
	relatedTasks: Array<KeyPairType>;
}

/** View-model для представления "Редактировать задачу". */
export type EditTaskType = {
	/** Дата выполнения */
	dueDate: string;
	dueDateDisabled: boolean;
	/** Текущий исполнитель */
	existedPerformer: string;
	/** UserName текущего исполнителя */
	existedPerformerUserName: string;
	performerDisabled: boolean;
	componentId: string;
	taskId: string;
};

export type EditTaskDataModel = {
	/** Идентификатор дела.  */
	fileId: string;
	/** Идентификатор компонента.  */
	componentId: string;
	/** Идентификатор исполнителя.  */
	newPerformer: string;
	/** Дата исполнения задачи. */
	newDueDate: string;
};

//////////////////////////////////////////////////////////////

export type TaskListItemType = FileCommonType & {
	/** RecId дела */
	deloId: string;
	/** Название дела */
	fileName: string;
	/** Название задачи */
	taskTitle: string;
	/** Статус  */
	taskStatus: string | number;
	/** Исполнитель  */
	performer: string;
	/** Автор  */
	author: string;
	/** Дата последнего изменения */
	updatedAt: Date | string | null;
	/** Не назначена */
	isNotAssigned: boolean;
};

export type TaskChangeStatusRequestBodyType = {
	taskStatusSelector: string;
	fileId: string;
	componentId: string;
};

export type TaskChangeStatusAnswerType = {
	status: string | null;
	statusIcon: string | null;
	description: string | null;
	characteristics: string | null;
	hasError: boolean;
	errorMessage: string | null;
};

export type ParticipantType = {
	id: string;
	attrs: Array<string>;
	contactPhone: string;
	email: string;
	firstName: string;
	lastName: string;
	metaData: any | null;
	patronymic: string;
	text: string;
};

export type FileTaskStatusType = {
	code: string;
	name: string;
	text: string;
	icon: string;
	color: string;
};

export const FileTaskStatuses: Array<FileTaskStatusType> = [
	{
		code: '0',
		name: 'unset',
		text: 'Открыта',
		icon: 'open',
		color: '#E1FFEB',
	},
	{
		code: '1',
		name: 'completed',
		text: 'Завершено',
		icon: 'ready',
		color: '#B0E5C4',
	},
	{
		code: '2',
		name: 'canceled',
		text: 'Отменено',
		icon: 'cancel',
		color: 'var( --Status-error-soft, #FEE2E2 )',
	},
	{
		code: '3',
		name: 'progress',
		text: 'В работе',
		icon: 'progress',
		color: '#FEF0CC',
	},
];
